import React from 'react'
import './messages.css'

const RecordMessages = ({ messages = [] }) => {
  if ((messages || []).length === 0) return null

  return (
    <div className="recordMessages--wrapper">
      <ul className='recordMessages--list'>
        {
          messages.map(({ message }, i) => (
            <li key={'messageID__' + i}>
              {message}
            </li>
          ))
        }
      </ul>
    </div>
  )
}

export default RecordMessages


// WEBPACK FOOTER //
// ./src/ui/record-messages/index.jsx